// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7b9831f","455":"dd886a53","547":"19aa3eac","677":"b021d5cb","813":"e699ce13","941":"275fbabf","977":"65eecddf"}[chunkId] + ".chunk.js";
};